import request from 'superagent';
import tree from '../state';
import config from '../config';

export function getSiteSearchResults(data) {
    return request.get(`${config.apiBase}/api/sitesearch/search`)
        .set('authorization', tree.get('token'))
        .query(data)
        .then(res => JSON.parse(res.text))
    ;
}



// WEBPACK FOOTER //
// ./src/services/siteSearchService.js